import { ModalType } from './models';

export type ShowReviewModalAction = {
  type: 'REVIEWS/MODALS/SHOW_REVIEW_MODAL';
  pullRequestUUID?: string;
  modalType: ModalType;
};

export type ClearReviewModalAction = {
  type: 'REVIEWS/MODALS/CLEAR_REVIEW_MODAL';
};

export type ModalAction = ShowReviewModalAction | ClearReviewModalAction;

export const actions = {
  showReviewModal: ({
    pullRequestUUID,
    modalType,
  }: {
    pullRequestUUID?: string;
    modalType: ModalType;
  }): ShowReviewModalAction => ({
    type: 'REVIEWS/MODALS/SHOW_REVIEW_MODAL',
    pullRequestUUID,
    modalType,
  }),
  clearReviewModal: (): ClearReviewModalAction => ({
    type: 'REVIEWS/MODALS/CLEAR_REVIEW_MODAL',
  }),
};
